
import { CircularProgress } from '@material-ui/core'
import React, { useState, useEffect, useContext } from 'react'
import ShipmentsCard from './cardBody/ShipmentsCard'
import InfiniteScroll from 'react-infinite-scroller';
import { StoreContext } from '../../../../store/Provider';

const ArrivedShipm = (props) => {
    const [shipmentList, setShipmentList] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageNumber, setPageNumber] = useState(1)
    const [hasMore, setHasMore] = useState(false)
    const [loadMore, setLoadMore] = useState(false)
    const context = useContext(StoreContext);

    useEffect(() => {
        setShipmentList(props.shipmentList.data)
        setPageNumber(props.shipmentList.pageNumber)
        setHasMore(props.shipmentList.hasMore)
        setLoadMore(props.shipmentList.loadMore)
        setLoading(props.shipmentList.loading)

    }, [props])

    if (loading) {
        return (
            <div className="loadingClass">
                <CircularProgress size="1.5rem" />
            </div>
        )
    }

    if (!loading && shipmentList.length === 0) {
        context.setRightHomeTitle(false);
        return (
            <div className="loadingClass" style={{ 'color': '#122d76' }}>
                No shipments found!!!
            </div>
        )
    }

    context.setRightHomeTitle(true);

    return (
        <div className="shipmentsCardsCol">
            <InfiniteScroll className="infiniteScroller"
                pageStart={0}
                loadMore={() => props.onLoadMore()}
                hasMore={hasMore}
                loader={
                    <div className="bottomLoader">
                        <CircularProgress size='1.5rem' />
                    </div>
                }
                useWindow={false}
            >
                {
                    shipmentList.map((element) => {
                        return (
                            <ShipmentsCard key={element.ShipmentId} shipmentList={element} />
                        )
                    })
                }
            </InfiniteScroll>
        </div>
    )
}

export default ArrivedShipm